/**
 * Created by Ning Jiang on 4/9/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WildNudgeGameConfig} from "../../WildNudgeGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TweenLite} from "gsap";

export class NudgeScatterWPView extends BaseView {

    private _layer:ScalableLayer;

    // private _allNumbers:PIXI.Sprite[];

    constructor() {
        super();

        this._layer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.POP_NUMBERS.name);
        // this._allNumbers = [];
    }

    public showAddFreespin(position:[number, number]):void {
        const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("freespinAdd1")[0]);
        sprite.anchor.set(0.5, 0.5);
        sprite.position.set(position[0], position[1]);
        sprite.scale.set(0.8, 0.8);
        // this._allNumbers.push(sprite);
        this._layer.addChild(sprite);

        // Cannot abort while freespin.
        TweenLite.to(sprite, 0.3, {alpha : 0, delay : 0.3});
        TweenLite.to(sprite, 0.7, {
            y : position[1] - 100,
            onComplete : () => {
                this._layer.removeChild(sprite);
                // ArrayHelper.removeFirstMatchElement(this._allNumbers, sprite);
            }
        });
    }
}